import React from "react";
import { View, StyleSheet } from "react-native";
import { useComponent, useTemplate } from "../providers/ConfigProvider";
import { LinearGradient } from "expo-linear-gradient";
import { TemplateProps } from "../../types";
import { ThemeOptions, useTheme } from "../providers/ThemeProvider";
import { MultiColumnSchedule } from "../components/MultiColumnSchedule";
import { Spacer } from "../components/ViewComponents";
import { TopBar } from "../components/TopBar";

const makeStyles = (theme: ThemeOptions) => {
  return StyleSheet.create({
    page: {
      flex: 1,
      backgroundColor: theme.background,
    },
    topBar: {
      borderBottomRightRadius: theme.borderRadius.large,
    },
    container: {
      flexDirection: "column",
      flexGrow: 1,
    },
  });
};

export const VerticalMultiSchedule = ({ onLoopComplete }: TemplateProps) => {
  const template = useTemplate();
  if (
    template !== "vertical_multi_day_schedule" &&
    template !== "vertical_multi_row_schedule"
  ) {
    throw new Error(
      `VerticalMultiSchedule: incorrect template provided - ${template}`,
    );
  }

  // On the wire, component keys are unchanged from landscape: vertical_multi_row_schedule
  // configs carry a multi_column_schedule component, and vertical_multi_day_schedule
  // configs carry a multi_day_schedule component. Avoids a JSONB migration.
  const componentKey =
    template === "vertical_multi_row_schedule"
      ? "multi_column_schedule"
      : "multi_day_schedule";
  const schedule = useComponent(componentKey, componentKey);
  if (schedule == null) {
    throw new Error("Failed to get schedule");
  }

  const theme = useTheme();
  const styles = makeStyles(theme);

  return (
    <View style={styles.page}>
      <LinearGradient
        colors={[theme.background, theme.accent]}
        style={styles.container}
        locations={[0.4, 1]}
        start={{ x: 0, y: 0 }}
        end={{ x: 0.5, y: 0.5 }}
      >
        <LinearGradient
          colors={[theme.background, theme.accent]}
          style={styles.topBar}
          start={{ x: 0, y: 1 }}
          end={{ x: 1, y: 1 }}
        >
          <TopBar orientation="portrait" />
        </LinearGradient>
        <Spacer size="small" />
        <MultiColumnSchedule
          data={schedule}
          onLoopComplete={onLoopComplete}
          orientation="portrait"
        />
      </LinearGradient>
    </View>
  );
};
